import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Hocs
import withReadPermission from 'hocs/withReadPermission';

// Containers
import HomePage from 'containers/HomePage';

const VerificationRoutes = () => (
  <Routes>
    <Route path="/:activePageId/*" element={<HomePage />} />
    <Route path="*" element={<Navigate to="/home" replace />} />
  </Routes>
);

export default withReadPermission(VerificationRoutes, {
  code: [200, 80011],
  description: 'access Verification Suites',
});
